import { useMemo } from "react";
import { useConferenceEnvironment } from "../components/ConferenceEnvironment";

export function useConfPlayerClassName(playerIndex: number | undefined) {
  const confEnv = useConferenceEnvironment();
  const className = useMemo(() => {
    if (confEnv === undefined || playerIndex === undefined) {
      return undefined;
    }
    if (playerIndex === confEnv?.conferenceState.bigIndex) {
      return "sdtv-player-container-big";
    } else {
      return "sdtv-player-container-small";
    }
  }, [playerIndex, confEnv]);
  return className;
}
